import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { isMsalSilentRenewalFrame } from './lib/msalRedirectBridge';

if (isMsalSilentRenewalFrame()) {
    // Hand the silent sign-in result to the main window. The app is loaded
    // only outside this branch so the hidden iframe stays small and fast
    // within MSAL's bridge timeout, and never starts a second MSAL instance.
    broadcastResponseToMainFrame().catch(console.error);
} else {
    void import('./bootstrap');
}
